<template>
    <div class="dialog_section dialog_height">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClickTabs">
            <el-tab-pane v-for="(item, index) in tabPane" :key="index" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
        <div class="table_box">
            <div class="round_box" :class="{ under: !isUnder }">
                <div class="ratioTop">{{ detailData && detailData.highPerc != null ? detailData.highPerc : '--' }}%</div>
                <div class="ratioBottom">{{ detailData && detailData.lowPerc != null ? detailData.lowPerc : '--' }}%</div>
                <div class="icon iconTop">
                    <div class="round_top">
                        <div class="round_text">
                            <div class="title">高</div>
                            <div class="subTitle">
                                {{ detailData && detailData.highN != null ? detailData.highN : '--' }}<span class="unit">{{ activeName == '11' ? '个车队' : '辆' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="icon iconBottom">
                    <div class="round_bottom">
                        <div class="round_text">
                            <div class="title">低</div>
                            <div class="subTitle">
                                {{ detailData && detailData.lowN != null ? detailData.lowN : '--' }}<span class="unit">{{ activeName == '11' ? '个车队' : '辆' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="round_middle">
                    <div class="num">{{ detailData && detailData.avgVal != null ? detailData.avgVal : '--' }}</div>
                    <div class="unit">平均值</div>
                </div>
            </div>
            <div class="table">
                <!--table表格部分 -->
                <el-table ref="multipleTable" :data="tableData" height="480" border v-loading="loading">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <template v-if="activeName == '11'">
                        <el-table-column prop="tenantName" label="车队名称"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="platNo" label="车牌号"></el-table-column>
                        <el-table-column prop="deviceNumber" label="设备号"></el-table-column>
                    </template>
                    <el-table-column prop="value" :label="labelName"></el-table-column>
                    <el-table-column v-if="riskLevelVisible" prop="riskLevel" label="风险级别">
                        <template slot-scope="scope">
                            <span>{{ scope.row.riskLevel || '--' }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页部分-->
                <el-pagination style="margin-top: 0.2rem" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="currentPage" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="10" :total="totalPage"> </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VehicleDetail',
    props: {
        dialogVisible: Boolean,
        detailQueryForm: Object
    },
    data() {
        return {
            // dialogVisible:true,
            detailTitle: '车辆驾驶里程分布',
            tabPane: [],
            isUnder: false, //是否低于平均值
            activeName: '1',
            riskLevelVisible: false,
            detailData: {}, //所有的车辆详情数据
            currentPage: 1, //当前页
            pageSize: 10, //一页多少条数据
            totalPage: 1, //总页数tableData:[],
            tableData: [],
            labelName: '总驾驶里程(km)',
            loading: true,
            tabPaneObj: {
                1: [
                    {
                        label: '日均驾驶里程',
                        name: '2'
                    },
                    {
                        label: '总驾驶里程',
                        name: '1'
                    }
                ],
                3: [
                    {
                        label: '日均驾驶时长',
                        name: '4'
                    },
                    {
                        label: '总驾驶时长',
                        name: '3'
                    }
                ],
                5: [
                    {
                        label: '日均行程数量',
                        name: '6'
                    },
                    {
                        label: '总行程数量',
                        name: '5'
                    }
                ],
                7: [
                    {
                        label: '周期内运行率',
                        name: '7'
                    }
                ],
                8: [
                    {
                        label: '平均速度',
                        name: '8'
                    },
                    {
                        label: '最高速度',
                        name: '9'
                    }
                ],
                10: [
                    {
                        label: '百公里三急一超数量',
                        name: '10'
                    }
                ],
                11: [
                    {
                        label: '周期内驾驶时长',
                        name: '11'
                    }
                ]
            },
            activeNameObj: {
                1: {
                    jogglePath: 'totalMile',
                    labelName: '总驾驶里程(km)'
                },
                2: {
                    jogglePath: 'avgMile',
                    labelName: '日均驾驶里程(km)'
                },
                3: {
                    jogglePath: 'totalDuration',
                    labelName: '总驾驶时长(h)'
                },
                4: {
                    jogglePath: 'avgDuration',
                    labelName: '日均驾驶时长(h)'
                },
                5: {
                    jogglePath: 'totalTripNum',
                    labelName: '总行程数量(条)'
                },
                6: {
                    jogglePath: 'avgTripNum',
                    labelName: '日均行程数量(条)'
                },
                7: {
                    jogglePath: 'usageRate',
                    labelName: '运行率(%)'
                },
                8: {
                    jogglePath: 'avgSpeed',
                    labelName: '平均速度(km/h)'
                },
                9: {
                    jogglePath: 'maxSpeed',
                    labelName: '最高速度(km/h)'
                },
                10: {
                    jogglePath: 'alarmNum100KM',
                    labelName: '百公里三急一超数量'
                },
                11: {
                    jogglePath: 'avgDuration',
                    labelName: '日均驾驶时长(h)'
                }
            }
        };
    },
    watch: {
        // detailQueryForm() {
        //     this.loadTabPane()
        //     this.handleClickTabs()
        // },
        activeName(val) {
            if (val == 4 || val == 8 || val == 9 || val == 10) {
                this.riskLevelVisible = true;
            } else {
                this.riskLevelVisible = false;
            }
        }
    },
    mounted() {
        this.loadTabPane();
        this.handleClickTabs();
    },
    methods: {
        loadTabPane() {
            this.tabPane = this.tabPaneObj[this.detailQueryForm.label];
            this.activeName = this.tabPane[0].name;
        },
        handleClickTabs() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.totalPage = 0;
            this.getTbodyData();
        },
        beforeClose(done) {
            this.$emit('beforeClose');
        },
        //获取tbody里的数据
        getTbodyData() {
            this.loading = true;
            this.detailData = {};
            this.tableData = [];
            let jogglePath = 'avgMile';
            let joggleData = {
                condition: this.detailQueryForm,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };

            // 根据tab切换接口路径和labelname
            jogglePath = this.activeNameObj[this.activeName].jogglePath;
            this.labelName = this.activeNameObj[this.activeName].labelName;
            let apiStr = this.activeName == '11' ? '/report/api/vehicleDashboard/fetchVehicleByTenantIndex/' : '/report/api/vehicleDashboard/fetchVehicleByIndex/';
            this.$request({ method: 'post', url: `${apiStr}${jogglePath}`, data: joggleData })
                .then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        res.data.avgVal = String(res.data.avgVal).indexOf('.') > -1 ? Number(res.data.avgVal).toFixed(2) : res.data.avgVal;
                        res.data.highPerc = String(res.data.highPerc).indexOf('.') > -1 ? Number(res.data.highPerc).toFixed(2) : res.data.highPerc;
                        res.data.lowPerc = String(res.data.lowPerc).indexOf('.') > -1 ? Number(res.data.lowPerc).toFixed(2) : res.data.lowPerc;

                        this.detailData = res.data;
                        if (this.detailData.lowN > this.detailData.highN) {
                            this.isUnder = true;
                        } else {
                            this.isUnder = false;
                        }
                        var tableData = res.data.pageData.list;

                        this.totalPage = parseInt(res.data.pageData.total);
                        if (tableData.length > 0) {
                            tableData.forEach((val, key) => {
                                val.harshNum = val.highN <= 0 ? '驾驶里程过短' : val.highN;
                                val.value = String(val.value).indexOf('.') > -1 ? Number(val.value).toFixed(2) : val.value;
                            });
                            this.tableData = tableData;
                        }
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                    this.$message.error('接口请求异常，请稍后重试！');
                });
        },
        //分页数据多少条change
        handleSizeChange(val) {
            this.pageSize = val;
            this.getTbodyData();
        },
        //分页：当前页改变之后的函数
        handleCurrentChange: function (val) {
            this.currentPage = Number(val);
            this.getTbodyData();
        }
    }
};
</script>
<style lang="less" scoped>
.table_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}
.round_box {
    width: 370px !important;
    height: 370px;
    border-radius: 50%;
    align-items: flex-start;
    position: relative;
    overflow: hidden;
    background: url(../../public/images/radiusBgc.png) no-repeat;
    background-size: 129%;
    background-position: -48px -50px;
    flex: none;
    color: #333;
    .ratioTop,
    .ratioBottom {
        width: 140px;
        height: 45px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        line-height: 45px;
        font-size: 24px;
        font-family: PingFang SC;
    }
    .ratioTop {
        top: 45px;
    }
    .ratioBottom {
        bottom: 45px;
    }
    .icon {
        width: 100px;
        height: 100px;
        background: url(../../public/images/iconTop.png) no-repeat;
        background-size: contain;
        position: absolute;
        left: 24px;
        top: 65px;
        z-index: 5;

        .round_top,
        .round_bottom {
            font-size: 0.2rem;
            position: absolute;
            left: 100px;
            min-width: auto;
            .round_text {
                display: flex;
                gap: 8px;
                align-items: center;
                width: auto;
                white-space: nowrap;
                div {
                    padding: 2px 4px;
                    white-space: nowrap;
                }
                .title,
                .subTitle {
                    font-size: 26px;
                }
                .subTitle {
                    font-size: 24px;
                }
                .unit {
                    font-size: 16px;
                }
            }
        }
        .round_top {
            top: 38px;
        }
        .round_bottom {
            top: 28px;
        }
    }
    .iconTop {
    }
    .iconBottom {
        background: url(../../public/images/iconBottom.png) no-repeat;
        background-size: contain;
        top: 210px;
        left: 24px;
    }
    .round_middle {
        width: 187px;
        height: 78px;
        border-radius: 45px;
        background: #fff;
        border: 1px solid #cbeeff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 50;
        font-size: 24px;
        text-align: center;
        padding: 15px 0;
        .num {
            font-size: 32px;
            font-weight: Semibold;
        }
        .unit {
            font-size: 18px;
        }
    }
}
.table {
    width: 70%;
}
.dialog_height {
    // height: 600px !important;
}
</style>
